import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { IRoute } from "src/common/typings/routes";
import { SupplyPartnersList } from "./pages/ListOfSupplyPartners";
import { SupplyPartnersModule } from "./supplyPartnersModule";

export const SupplyPartnersRoute: IRoute = {
  title: "Supply Partners",
  path: "/supply-partners",
  icon: SupervisorAccountIcon,
  component: SupplyPartnersModule,
  subRoutes: [
    {
      component: SupplyPartnersList,
      path: "/details",
      title: "Supply Partners",
    },
  ],
};
